import { render, staticRenderFns } from "./addBookSAA.vue?vue&type=template&id=6c2c1c08&"
import script from "./addBookSAA.vue?vue&type=script&lang=js&"
export * from "./addBookSAA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports